import { render, staticRenderFns } from "./AiFeatureDialog.vue?vue&type=template&id=497e9807&scoped=true"
import script from "./AiFeatureDialog.vue?vue&type=script&lang=js"
export * from "./AiFeatureDialog.vue?vue&type=script&lang=js"
import style0 from "./AiFeatureDialog.vue?vue&type=style&index=0&id=497e9807&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e9807",
  null
  
)

export default component.exports